import { useBridge, canBridgeUse } from './bridge';

export async function jump(url) {
    if (await canBridgeUse('webview', 'open')) {
        const nameSpaceApi = 'webview.open';
        return await useBridge(nameSpaceApi, { url });
    }
    if (await canBridgeUse('tool', 'loadUrlOnNewPage')) {
        const nameSpaceApi = 'tool.loadUrlOnNewPage';
        const params = {
            url: url,
            type: 'back',
        };
        return await useBridge(nameSpaceApi, params);
    }
    window.location.href = url;
}
export const isIOS = () => {
    const ua = typeof window !== 'undefined' ? navigator.userAgent : '';
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};
// 跳转的是端内链接
export function jumpViewProgress(soid) {
    const host = window.location.host;
    const isProd = host.indexOf('staging.kuaishou.com') === -1;
    const url = isProd ? 'https://csc.m.kuaishou.com' : 'https://csc-center.staging.kuaishou.com';
    const entranceId = isProd ? 1 : 1490;
    jump(`${url}/service/?enableWK=1&layoutType=4#/service-detail?soid=${soid}&entranceId=${entranceId}`);
}

export function isStaging() {
    const host = window.location.host;
    return host.indexOf('staging.kuaishou.com') >= 0;
}
export function isPre() {
    const host = window.location.host;
    return host.indexOf('test.gifshow.com') >= 0;
}

export function parse(str) {
    if (!str) {
        return {};
    }
    return str.split('&').reduce((pre, cur) => {
        const [key = '', value = ''] = cur.split('=');
        pre[key] = value;
        return pre;
    }, {});
}

export function getUrlParam(name) {
    const res = parse(location.search.slice(1));

    const hashSearchIndex = location.hash && location.hash.indexOf('?') || 0;

    // 优先哈希中的参数
    if (~hashSearchIndex) {
        Object.assign(res, parse(location.hash && location.hash.slice(hashSearchIndex + 1)));
    }

    return `${res[name] || ''}`;
}

export const FILE_TYPE = {
    IMAGE: 1,
    VIDEO: 4,
    IMAGE_VIDEO: 5,
};

export function getAutoMediaType(accept) {
    const parts = accept.split(',').map(part => part.trim());
    const hasImage = parts.some(part => part.includes('image'));
    const hasVideo = parts.some(part => part.includes('video'));
    if (!accept || hasImage && hasVideo) {return FILE_TYPE.IMAGE_VIDEO;}
    if (hasImage) {return FILE_TYPE.IMAGE;}
    if (hasVideo) {return FILE_TYPE.VIDEO;}
    return FILE_TYPE.IMAGE_VIDEO;
}

/**
 * 安全解析JSON字符串，过滤空字符串、空对象、空数组
 * @param {string} jsonString - 要解析的JSON字符串
 * @returns {any|null} 解析后的数据，无效数据返回null
 */
export function safeParseJSON(jsonString) {
    if (!jsonString || typeof jsonString !== 'string' || !jsonString.trim()) {
        return null;
    }
    try {
        const parsed = JSON.parse(jsonString);
        // 检查不能是空对象、空数组
        if (parsed
            && !(Array.isArray(parsed) && parsed.length === 0)
            && !(typeof parsed === 'object' && Object.keys(parsed).length === 0)) {
            return parsed;
        }
        return null;
    } catch (error) {
        console.error('JSON.parse failed:', error);
        return null;
    }
}
